import { store } from 'app/shared/store/store';
import { DelayMessageTimer } from 'app/shared/models/delay-message-timer';

class DelayMessageService {
  private timers: DelayMessageTimer[] = null;

  constructor() {
    this.timers = [
      {
        timer: null,
        timeout: 15000,
        message: 'Things are taking a little longer than expected, please wait.'
      },
      {
        timer: null,
        timeout: 60000,
        message: `We're still searching - it can take a couple of minutes, please wait.`
      }
    ];
  }
  public startAllTimers(): void {
    this.timers.forEach((item) => {
      item.timer = this.startTimer(item.message, item.timeout);
    });
  }

  public stopAllTimers(): void {
    this.timers.forEach((item) => {
      this.stopTimer(item.timer);
      item.timer = null;
    });
  }

  public startTimer(delayMessage: string, timeout: number): NodeJS.Timeout {
    return setTimeout(() => {
      store.set('delayMessage', delayMessage);
    }, timeout);
  }

  public stopTimer(timer: NodeJS.Timeout): void {
    store.set('delayMessage', null);
    if (timer) {
      clearTimeout(timer);
    }
  }
}

export const delayMessageService = new DelayMessageService();
